<script setup lang="ts">
import type { ComponentPublicInstance } from 'vue';

const emit = defineEmits<{
  toggle: [iataCode: string, value: boolean];
  solo: [iataCode: string];
}>();

const resultsStore = useSearchResultIndexStore();

const VISIBLE_COUNT = 5;

const showAll = ref(false);
const buttonReference = useTemplateRef<ComponentPublicInstance>('button');

const visibleItems = computed(() =>
  showAll.value ? resultsStore.filteredCarriers : resultsStore.filteredCarriers.slice(0, VISIBLE_COUNT),
);
const hasMore = computed(() => resultsStore.filteredCarriers.length > VISIBLE_COUNT);

watch(showAll, async (value) => {
  if (!value) return;
  await nextTick();
  const element: unknown = buttonReference.value?.$el;
  if (!(element instanceof HTMLElement)) return;
  element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
});
</script>

<template>
  <div class="flex flex-col gap-3">
    <UiCustomFilterLabeledCheckbox
      v-for="item in visibleItems"
      :id="item.iataCode ?? ''"
      :key="item.iataCode ?? ''"
      :label="item.name ?? item.iataCode ?? ''"
      :model-value="item.selected"
      @update:model-value="(val) => emit('toggle', item.iataCode ?? '', val)"
    >
      <template #trailing>
        <div class="flex w-fit items-center gap-1.5">
          <button
            type="button"
            class="text-base font-semibold text-text-accent-700 opacity-0 transition focus:opacity-100 group-hover:opacity-100"
            :aria-label="`${$t('components.results.filters.solo')} ${item.name ?? item.iataCode}`"
            @click.stop.prevent="emit('solo', item.iataCode ?? '')"
          >
            {{ $t('components.results.filters.solo') }}
          </button>
          <span
            v-if="item.price?.averagePerPax"
            class="text-sm font-normal text-secondary-foreground"
            >{{ usePriceFormat(item.price.averagePerPax) }}</span
          >
        </div>
      </template>
    </UiCustomFilterLabeledCheckbox>
  </div>
  <UiButton
    v-if="hasMore"
    ref="button"
    variant="tertiary"
    color="gray"
    padding="none"
    class="w-fit gap-1 self-start font-normal text-gray-600 underline"
    @click="showAll = !showAll"
  >
    {{
      showAll ? $t('components.results.filters.showLessAirlines') : $t('components.results.filters.showMoreAirlines')
    }}
  </UiButton>
</template>
